export default "__VITE_ASSET__DJlIneF3__"